import {Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControlLabel, Grid, Radio, Stack, Typography, useTheme} from "@mui/material";
import { useRecoilState, useSetRecoilState } from "recoil";
import { counterSaleManagementValueState, listVehiclesReadyState, rentalAgreementFillingValueState, bookingDataValueState, raFillingAccordionValidationState } from "../create-ra/state";

import { raDetailState } from "../ra-detail/state";
import { useMutation, useQuery, UseQueryResult } from "@tanstack/react-query";
import { useParams, useNavigate } from "react-router-dom";
import { findCounterSaleManagement, listVehiclesReadyToRent, raEdit, raFilling as raFillingService, retriveDraftRA, fetchAvailableAncillaries, fetchCounterSaleManagement, raUpdateByCounterSale} from "../create-ra/services/http.services";
import { useContext, useEffect, useMemo, useState } from "react";
import { GlobalContext } from "../../../util/state/GlobalContextProvider";
import { snackbarTypes } from "../../../util/state/globalVariables";
import { useTranslation } from "react-i18next";
import { fetchRaDetail } from "../ra-detail/services/http.services";
import { FormAutocomplete, FormRadioGroup, FormTextField } from "../common/form-fields-wrappers";
import { ICounterSale, ICSAncillary, IRADAncillary, IRaDetailView, IRaEditForm, IRaFillingForm, TYesNo } from "../models/models";
import { FormProvider, useFieldArray, useForm, useFormContext } from "react-hook-form";
import { deepClone } from "../../../util/state/commonFunctions";
import { RA_FILLING_FORM_INITIAL_VALUE, RA_FILLING_FORM_VALIDATION_SCHEMA } from "../create-ra/ra-filling/config";
import { yupResolver } from "@hookform/resolvers/yup";
import _ from "underscore";
import { getMobilityStoreBySapId } from "../search-dms/dmsSearch.actions";
import { AxiosError } from "axios";
import AncillariesInfoTest from "./ancillaries/AncillariesInfo";
import SectionHeader from "../../../util/component/SectionHeader";
import { raFillingPricingErrorsManagement } from "../../network/create-ra/ra-filling/utils";
import {checkAncillaryUnitsMileage, formatCurrency, getLocaleByLang, isImmutableRa, isRetail} from "../../network/utils";
import {ERROR_DETAIL_LIST, PA_ID_NUMBER_DEFAULT_VALUE} from "../../network/create-ra/config";
import {LOCALES} from "../config";

function EditRa() {
    const {t} = useTranslation(['network', 'translation']);
    const theme = useTheme();
    const params = useParams(); // params.id
    const { dispatchGlobalData } = useContext(GlobalContext);
    const [loading, setLoading] = useState(true);
    const [raFilling, setRaFilling] = useRecoilState(rentalAgreementFillingValueState);
    const [listVehiclesReady, setListVehiclesReady] = useRecoilState(listVehiclesReadyState);
    const [selectionCarOptionList, setSelectionCarOptionList] = useState({acriss: [], sipp: [], plate: []});
    const [brandModelDescr, setBrandModelDescr] = useState("");

    const [counterSaleManagement, setCounterSaleManagement] = useRecoilState(counterSaleManagementValueState);
    const [bookingDataValue, setBookingDataValue] = useRecoilState(bookingDataValueState);
    //const [raFillingAccordionValidationValue, setRaFillingAccordionValidationValue] = useRecoilState(raFillingAccordionValidationState);
    const setRaFillingAccordionValidation = useSetRecoilState(raFillingAccordionValidationState);
    const [raDetail, setRaDetail] = useRecoilState(raDetailState);
    const appLanguage = useTranslation();


    const [isSaveDialogOpen, setIsSaveDialogOpen] = useState(false);
    const handleOpenSaveDialog = () => setIsSaveDialogOpen(true);
    const handleCloseSaveDialog = () => setIsSaveDialogOpen(false);

    const [flagCounterSaveGetOn, setFlagCounterSaveGetOn] = useState<any>(null);
	const [flagUpdateDefaultFormValue, setFlagUpdateDefaultFormValue] = useState<boolean>(false);
    const [ntwOfferId, setNtwOfferId] = useState<string>(''); // flag che gestisce il salvataggio del ntwOfferId in localstorage
	const [bookingEntity, setBookingEntity] = useRecoilState(bookingDataValueState);
    const navigate = useNavigate();

        const locale = useMemo((): 'it-IT' | 'en-IN' | 'fr-FR' => {
            return getLocaleByLang(appLanguage.i18n.language);
        }, [appLanguage.i18n.language]);


    /////////////////////////////////////////////////////////////////////// USE EFFECT START

    useEffect(() => {
        raDetailQuery.refetch();
    }, []);



  //   useEffect(() => {
	// 	if (!!flagCounterSaveGetOn) {
  //           console.log('useEffect flagCounterSaveGetOn!' + flagCounterSaveGetOn);
	// 		invokeCounterSaleManagement(flagCounterSaveGetOn);
	// 	}

	// }, [flagCounterSaveGetOn]);

    useEffect(() => {

      //console.log('LB raFilling',raFilling);


      //console.log('LB raFilling',raFilling);

        if (!raFilling?.generalInfo?.pickupLocation?.code) {
            console.log('useEffect RaFilling STOPPED no code on raFilling: ' + raFilling);
            return;
        }

        console.log('useEffect RaFilling: ' + raFilling);

        console.log('useEffect RaFilling plateNumber: ' + raFilling.generalInfo.plateNumber);

        const acrissObj = findObjectByPlate(raFilling.generalInfo.plateNumber, listVehiclesReady ?? []);
        raFillingDataForm.setValue('vehicleDetails.plate', acrissObj);

        console.log('useEffect RaFilling acrissObj: ' + acrissObj);
        handleChangePlate(null, acrissObj);

        // manage Ancillary Info
        bookedAncillariesInfo.remove();
        raFilling?.ancillariesInfo?.ancillaries?.forEach((elem: ICSAncillary, index: number) => {
                bookedAncillariesInfo.append(elem);
                raFillingDataForm.setValue(`ancillariesInfo.booked.${index}`, elem);
            });


        console.log('useEffect RaFilling bookedAncillariesInfo: ' + bookedAncillariesInfo);

        counterSaleAncillariesInfo.remove();
        raFilling?.ancillariesInfo?.ancillariesAdded?.forEach((elem: any, index: number) => {
                counterSaleAncillariesInfo.append(elem);
                raFillingDataForm.setValue(`ancillariesInfo.counterSale.${index}`, elem);
            });
        console.log('useEffect RaFilling bookedAncillariesInfo: ' + counterSaleAncillariesInfo);

        listVehiclesReadyToRentMutation
            .mutate({
                tenant: raFilling?.vehicle?.idTenant,
                "locations": [{
                    id: raFilling?.generalInfo?.pickupLocation?.code,
                    type: "LMS"
                }],
                "keyless": true,
                bookingId: bookingEntity.bookingDetail.idBooking,
            } as any);

        

        getMobilityStoreBySapId(raFilling?.generalInfo?.dmsIdentificationCode?.code)
            .then((res:any) => {
                const { keyLessInfo } = res?.at(0);
                raFillingDataForm.setValue('keylessInfo', keyLessInfo);
            })
            .catch((err: AxiosError) => {
                console.error(err);
            });

        // counterSaleManagementMutation.mutateAsync({idRentalAgreement: params.id})
        //     .then(counterSale => {
        //         setCounterSaleManagement({previous: counterSale, last: counterSale});
        //         console.log('TEST2 CounterSaleManagement: ' + JSON.stringify(counterSaleManagement));
        //     })

    }, [raFilling]);


    useEffect(() => {
        console.log('useEffect listVehiclesReady: ' + listVehiclesReady);
        handleReset();
    }, [listVehiclesReady])


    useEffect(() => {
      if (
        !_.isEqual(
          counterSaleManagement.previous,
          counterSaleManagement.last
        ) &&
        !!counterSaleManagement.last &&
        !counterSaleManagementMutation.isLoading
      ) {
        //invokeCounterSaleManagement(flagCounterSaveGetOn);
        createPayloadForAncillaryUpdate();
      }
    
    }, [counterSaleManagement]);

      /////////////////////////////////////////////////////////////////////// USE EFFECT END


      const raDetailQuery = useQuery(
        ["raDetail", { idRentalAgreement: params.id }],
        () => fetchRaDetail({ idRentalAgreement: params.id }),
        {
          enabled: false,
          onSuccess: (data) => {

            console.log("raDetailQuery data: " + JSON.stringify(data));

            //Needed for Ancillaries and init of value
            setRaDetail(data);

            //Needed for vehicle and maybe for update to BE
            setRaFilling(data);

            setRaFillingAccordionValidation({
              generalInfo: false,
              firstBillingOwnerInfo: false,
              secondBillingOwnerInfo: false,
              ancillariesInfo: false,
            });

            initAncillaries(data);    //TODO

          },
          onError: async (error: any) => {
            console.log("raDetailQuery Error: " + error);
            viewErrorMessage("customerData.message.error.tryLater");
          },
        }
      );

      const invokeCounterSaleManagement = async (payload: any) => {
        counterSaleManagementMutation.mutate(payload);
      };

      //Retrive info about ancillaries
      const counterSaleManagementMutation = useMutation(
        findCounterSaleManagement,
        {
          onSuccess: (response: ICounterSale) => {

            console.log("findCounterSaleManagement response: " + JSON.stringify(response));

            setCounterSaleManagement({
              previous: counterSaleManagement.last,
              last: response,
            });

          },
          onError: async (error: any) => {
            console.log("findCounterSaleManagement error: " + error);
            viewErrorMessage("customerData.message.error.tryLater");
          },
        }
      );


      const initAncillaries = (data: any) => {
        console.log("initAncillaries data: " + data);
        let ntwOfferId = "";
        let raNtwOfferIdLS = localStorage.getItem("raNtwOfferId");

        //console.log("initAncillaries raNtwOfferIdLS: " + raNtwOfferIdLS);

        if (!!raNtwOfferIdLS) {
          raNtwOfferIdLS = JSON.parse(raNtwOfferIdLS);
          if (!!raNtwOfferIdLS?.[data.generalInfo.reservationNumber]) {
            ntwOfferId = raNtwOfferIdLS[data.generalInfo.reservationNumber];
          }
        }

        console.log("initAncillaries ntwOfferId: " + ntwOfferId);

        const payload = {
          idRentalAgreement: data.idRentalAgreement,
          upsell: false, //formValue.generalInfo.upSell === 'YES',
          selectedAcrissSipp: null, //selected,
          ntwOfferId: ntwOfferId,
          bookedAncillaryList: data.ancillariesInfo.ancillaries.map(
            (elem: any) => {
              return {
                ancillaryCode: elem.ancillaryCode,
                units: elem.ancillaryUnits,
                mileage: elem.ancillaryMileage,
                address: elem.address,
                ancillarySubType: elem.ancillarySubType,
              };
            }
          ),
          counterSaleAncillaryList: [],
          init: 0,
        };

        console.log("initAncillaries payload: " + payload);

        setFlagCounterSaveGetOn(payload);
        setNtwOfferId(ntwOfferId);
        //invokeCounterSaleManagement(payload);
        fetchCounterSaleManagement(payload).then((response) => {
          console.log("initAncillaries fetchCounterSaleManagement response: " + response);
          setCounterSaleManagement({
            previous: counterSaleManagement.last,
            last: response,
          });
        }).catch((error) => {
          console.log("initAncillaries fetchCounterSaleManagement error: " + error);
          viewErrorMessage("customerData.message.error.tryLater");
        })
        //createPayloadForAncillaryUpdate();
      };

      const createPayloadForAncillaryUpdate = () => {
        const formValue = raFillingDataForm.getValues();
        let selected = null;
        if (!!formValue.vehicleDetails?.plate) {
          selected = {
            code: formValue.vehicleDetails.plate.acrissCode,
            description: formValue.vehicleDetails.plate.acrissLabel,
          };
        } else if (!!formValue.vehicleDetails?.acriss) {
          selected = {
            code: formValue.vehicleDetails.acriss.code,
            description: formValue.vehicleDetails.acriss.description,
          };
        }

        const cs = deepClone(counterSaleManagement);

        const csM = {
          idRentalAgreement: raDetail.idRentalAgreement,
          upsell: raDetail.generalInfo.upSell,
          selectedAcrissSipp: selected,
          ntwOfferId: cs.last.ntwOfferId,
          bookedAncillaryList: cs.last.bookedAncillaryList.map((elem: any) => {
            return {
              ancillaryCode: elem.ancillaryCode,
              units: elem.units,
              mileage: elem.mileage,
              address: elem.address,
              ancillarySubType: elem.ancillarySubType || elem.subtype,
            };
          }),
          counterSaleAncillaryList: [], //cs.last.counterSaleAncillaryList.map((elem: any) => {return {ancillaryCode: elem.ancillaryCode, units: elem.units, mileage: elem.mileage, address: elem.address, ancillarySubType: elem.ancillarySubType || elem.subtype}}),
          init: 0,
        };

        console.log("createPayloadForAncillaryUpdate csM: " + JSON.stringify(csM));

        //Update ancillaries?
        fetchCounterSaleManagement(csM).then((response) => {
          console.log("createPayloadForAncillaryUpdate fetchCounterSaleManagement response: " + JSON.stringify(response));
          setCounterSaleManagement({
            previous: counterSaleManagement.last,
            last: response,
          });
        });
      };

      const createAncillariesFromCountSaleAndUpdate = (
        counterSaleManagement: any,
        raFillingDataForm: any
      ) => {

        console.log("createAncillariesFromCountSaleAndUpdate bookedAncillaryList: " + counterSaleManagement.bookedAncillaryList);

        const formValue = raFillingDataForm.getValues();

        let selected = null;
        
        if (!!formValue.vehicleDetails?.plate) {
          selected = {
            code: formValue.vehicleDetails.plate.acrissCode,
            description: formValue.vehicleDetails.plate.acrissLabel,
          };
        } else if (!!formValue.vehicleDetails?.acriss) {
          selected = {
            code: formValue.vehicleDetails.acriss.code,
            description: formValue.vehicleDetails.acriss.description,
          };
        }

        const csM = {
          idRentalAgreement: raDetail.idRentalAgreement,
          upsell: raDetail.generalInfo.upSell,
          selectedAcrissSipp: selected,
          ntwOfferId: counterSaleManagement.ntwOfferId,
          bookedAncillaryList: counterSaleManagement.bookedAncillaryList.map(
            (elem: any) => {
              return {
                ancillaryCode: elem.ancillaryCode,
                units: elem.units,
                mileage: elem.mileage,
                address: elem.address,
                ancillarySubType: elem.ancillarySubType || elem.subtype,
              };
            }
          ),
          counterSaleAncillaryList: [], //cs.last.counterSaleAncillaryList.map((elem: any) => {return {ancillaryCode: elem.ancillaryCode, units: elem.units, mileage: elem.mileage, address: elem.address, ancillarySubType: elem.ancillarySubType || elem.subtype}}),
          init: 0,
        };

        console.log("createAncillariesFromCountSaleAndUpdate csM: " + csM);

        fetchCounterSaleManagement(csM)
          .then((response) => {

            console.log("createAncillariesFromCountSaleAndUpdate fetchCounterSaleManagement response: " + response );

            // raUpdateByCounterSale({idRentalAgreement: raDetail.idRentalAgreement})
            //   .then((updateResponse) => {
            //     console.log("createAncillariesFromCountSaleAndUpdate raUpdateByCounterSale response: " + updateResponse );
            //     handleCloseSaveDialog();
            //     returnToDetail();
            //   })
            //   .catch((err: AxiosError) => {
            //     console.log("createAncillariesFromCountSaleAndUpdate raUpdateByCounterSale error: " +err);
            //     viewErrorMessage(err.message);
            //     handleCloseSaveDialog();
            //   });

            raEdit({
              keyless: true,
              idRentalAgreement: params.id}).then((response: any) => {
                console.log("createAncillariesFromCountSaleAndUpdate raEdit response: " + response );
              }).catch((error : any) =>{
                console.log("createAncillariesFromCountSaleAndUpdate raEdit error: " + error );
              });

            //handleCloseSaveDialog();
            //returnToDetail();
          })
          .catch((err: AxiosError) => {
            console.log("createAncillariesFromCountSaleAndUpdate fetchCounterSaleManagement error: " + err);

            viewErrorMessage(err.message);
          });
      };

      //NOT USED??
    const raFillingDataForm = useForm<IRaEditForm>({
        mode: 'onChange',
		// defaultValues: deepClone(RA_FILLING_FORM_INITIAL_VALUE),
		// resolver: yupResolver(
		// 	RA_FILLING_FORM_VALIDATION_SCHEMA,
		// 	{},
        //     {rawValues: true}
		// )
	});

    const bookedAncillariesInfo = useFieldArray<IRaEditForm>({
        control: raFillingDataForm.control,
        name: "ancillariesInfo.booked"
    });

    const counterSaleAncillariesInfo = useFieldArray<IRaEditForm>({
        control: raFillingDataForm.control,
        name: "ancillariesInfo.counterSale"
    });

    const listVehiclesReadyToRentMutation = useMutation(
      listVehiclesReadyToRent,
      {
        onSuccess: (response: any) => {
          if (!response[0]?.vehicles) {
            setListVehiclesReady([]);
            return;
          }

          const list = response[0]?.vehicles?.map((elem: any) => {
            elem["fullDescription"] =
              elem.plate +
              " | " +
              elem.brandDescription +
              " | " +
              elem.modelDescription +
              " | " +
              elem.enginePowerGroupCode;
            return elem;
          });

          setListVehiclesReady(list);
          console.dir(list);
        },
        onError: async (error: any) => {
          viewErrorMessage("customerData.message.error.tryLater");
        },
      }
    );


    const handleReset = (e?: React.SyntheticEvent) => {
        console.log('handleReset!');
        e?.stopPropagation();

        if (!listVehiclesReady) {
            raFillingDataForm.setValue('vehicleDetails.acriss', null);
            raFillingDataForm.setValue('vehicleDetails.sipp', null);
            raFillingDataForm.setValue('vehicleDetails.plate', null);
            handleChangeAcriss(e || null, null);
            setBrandModelDescr("");
        } else {
            const acrissObj = findObjectByPlate(raFilling.generalInfo.plateNumber, listVehiclesReady ?? []);
            raFillingDataForm.setValue('vehicleDetails.plate', acrissObj);
            handleChangePlate(null, acrissObj);
        }
    }

    const handleChangeAcriss = (event: null | React.SyntheticEvent, value: any) => {
        if (!!event) {
            event.stopPropagation();
        }

        if (!listVehiclesReady) {
            return;
        }

        raFillingDataForm.setValue('vehicleDetails.sipp', null);
        raFillingDataForm.setValue('vehicleDetails.plate', null);
        // setVehicleFormFields(null);
        const sco = Object.assign({}, selectionCarOptionList);

        if (sco.acriss.length === 0) {
            // @ts-ignore
            sco['acriss'] = [...new Map(listVehiclesReady.map((item: any) => [item['acrissCode'], item])).values()]
                    .map(elem => { return {code: elem.acrissCode, description: elem.acrissLabel}});
        }

        if (!value) {
            // @ts-ignore
            sco['sipp'] = [...new Map(listVehiclesReady.map(item => [item['sippCode'], item])).values()]
                            .map(elem => {
                                return {
                                    code: elem.sippCode,
                                    description: elem.sippLabel,
                                    acrissCode: elem.acrissCode,
                                    acrissLabel: elem.acrissLabel
                                };
                            });
            // @ts-ignore
            sco['plate'] = listVehiclesReady;
        }
        else {
            // @ts-ignore
            sco['sipp'] = [...new Map(listVehiclesReady.map(item => [item['acrissCode'] + item['sippCode'], item])).values()]
                            .filter(elem => elem.acrissCode === value.code)
                            .map(elem => {
                                return {
                                    code: elem.sippCode,
                                    description: elem.sippLabel,
                                    acrissCode: elem.acrissCode,
                                    acrissLabel: elem.acrissLabel
                                };
                            });

            // @ts-ignore
            sco['plate'] = listVehiclesReady.filter(elem => elem.acrissCode === value.code);
        }
        setSelectionCarOptionList(sco);
    }

    const handleChangeSipp = (event: null | React.SyntheticEvent, value: any) => {
        if (!!event) {
            event.stopPropagation();
        }

        if (!listVehiclesReady) {
            return;
        }

        raFillingDataForm.setValue('vehicleDetails.plate', null);
        // setVehicleFormFields(null);

        const acrissCode = raFillingDataForm.getValues('vehicleDetails.acriss');

        const sco = Object.assign({}, selectionCarOptionList);

        if (sco.acriss.length === 0) {
            // @ts-ignore
            sco['acriss'] = [...new Map(listVehiclesReady.map((item: any) => [item['acrissCode'], item])).values()]
                .map(elem => { return {code: elem.acrissCode, description: elem.acrissLabel}});
        }

        if (!value) {
            // @ts-ignore
            sco['plate'] = listVehiclesReady.filter((elem: any) => !acrissCode || elem.acrissCode === acrissCode.code);
        }
        else {
            if (!!value.code && !acrissCode) { // !null && null
                raFillingDataForm.setValue('vehicleDetails.acriss', {code: value.acrissCode, description: value.acrissLabel});
            }

            if (!!acrissCode) {
                sco['plate'] = listVehiclesReady.filter((elem: any) => acrissCode.code === elem.acrissCode && elem.sippCode === value.code);
            } else {
                sco['plate'] = listVehiclesReady.filter((elem: any) => elem.sippCode === value.code);
            }
        }
        setSelectionCarOptionList(sco);
    }

    const handleChangePlate = (event: React.SyntheticEvent | null, value: any) => {
        if(event !== null ) {
            event.stopPropagation();
        }

        if (!listVehiclesReady) {
            return;
        }

        let acrissCode: any, sippCode: any;

        if (!!value)  {
            raFillingDataForm.setValue('vehicleDetails.acriss', {code: value.acrissCode, description: value.acrissLabel});
            raFillingDataForm.setValue('vehicleDetails.sipp', {code: value.sippCode, description: value.sippLabel, acrissCode: value.acrissCode, acrissLabel: value.acrissLabel});
            acrissCode = {code: value.acrissCode, description: value.acrissLabel};
            sippCode = {code: value.sippCode, description: value.sippLabel, acrissCode: value.acrissCode, acrissLabel: value.acrissLabel};
        }
        else {
            acrissCode = raFillingDataForm.getValues('vehicleDetails.acriss');
            sippCode = raFillingDataForm.getValues('vehicleDetails.sipp');
        }

        const sco = Object.assign({}, selectionCarOptionList);

        if (sco.acriss.length === 0) {
            // @ts-ignore
            sco['acriss'] = [...new Map(listVehiclesReady.map((item: any) => [item['acrissCode'], item])).values()]
                .map(elem => { return {code: elem.acrissCode, description: elem.acrissLabel}});
        }

        sco['plate'] = listVehiclesReady;
        if (!!acrissCode) {
            sco['plate'] = sco['plate'].filter((elem: any) => elem.acrissCode === acrissCode.code)
        }

        if (!!sippCode) {
            sco['plate'] = sco['plate'].filter((elem: any) => elem.sippCode === sippCode.code)
        }

        if (!!acrissCode) {
            // @ts-ignore
            sco['sipp'] = [...new Map(listVehiclesReady.map(item => [item['acrissCode'] + item['sippCode'], item])).values()]
                                .filter((elem: any) => elem.acrissCode === acrissCode.code)
                                .map(elem => {
                                    return {
                                        code: elem.sippCode,
                                        description: elem.sippLabel,
                                        acrissCode: elem.acrissCode,
                                        acrissLabel: elem.acrissLabel
                                    };
                                });
        } else {
            // @ts-ignore
            sco['sipp'] = [...new Map(listVehiclesReady.map(item => [item['sippCode'], item])).values()]
                                        .map(elem => {
                                            return {
                                                code: elem.sippCode,
                                                description: elem.sippLabel,
                                                acrissCode: elem.acrissCode,
                                                acrissLabel: elem.acrissLabel
                                            };
                                        });
        }

        setSelectionCarOptionList(sco);

        // set form value
        setVehicleFormFields(value);

        setBrandModelDescr((!!value?.brandDescription ? value.brandDescription + ' ' : '') + (!!value?.modelDescription ? value.modelDescription: ''));

        if (!!counterSaleManagement?.last) {
            const csmClone = deepClone(counterSaleManagement.last);
            csmClone.selectedAcriss = {code: value?.acrissCode, description: value?.acrissLabel};
            setCounterSaleManagement({previous: counterSaleManagement.last, last: csmClone});
        }

        setLoading(false);
    }

	function findObjectByPlate(input: any, arr: any) {
		for (let i = 0; i < arr.length; i++) {
			if (arr[i].plate !== input) continue
            return arr[i]
		}
    return fromRaDetailToAcrissObj(raDetail);
	}


    const fromRaDetailToAcrissObj = (raDetail: any) =>{
        let vehicle = raDetail.vehicle;
        let spaceDesc = ' | '


        if(vehicle == null){
          return null;
        }

        return {
            id: null, 
            vin: vehicle.vin, 
            plate: vehicle.plate.code, 
            internalNumber: vehicle.internalNumber,
            enginePowerGroupCode: vehicle.enginePowerGroupCode,
            termicTankCapacity: vehicle.termicTankCapacity,
            electricTankCapacity: vehicle.electricTankCapacity,
            currentTermicTankFilling: vehicle.currentTermicTankFilling,
            currentElectricTankFilling: vehicle.currentElectricTankFilling,
            kms: vehicle.kilometersOnStart,
            carSegmentDescription: vehicle.carSegmentDescription,
            carClassDescription: vehicle.carClassDescription,
            acrissCode: vehicle.acrissId,
            acrissLabel: vehicle.acrissDescription,
            sippCode: vehicle.sippId,
            sippLabel: vehicle.sippDescription,
            rfidCardNumber: vehicle.rfidCardNumber,
            rfidCardStatus: vehicle.rfidCardStatus,
            modelDescription: vehicle.modelDescription,
            brandDescription: vehicle.brandDescription,
            carSegmentLevel: vehicle.carSegmentLevel,
            tenant: vehicle.tenant,
            keyless: vehicle.keyless,
            fullDescription: (vehicle.plate.code + spaceDesc + vehicle.brandDescription + spaceDesc + vehicle.modelDescription + spaceDesc + vehicle.enginePowerGroupCode)
            };
    }


    const setVehicleFormFields = (value: any) => {
        console.log('setVehicleFormFields Start value: ' + value);

        if(raDetail == null){
          console.log('setVehicleFormFields raDetail is NULL!');
          return;
        }


        if(value === null){
            value = fromRaDetailToAcrissObj(raDetail);
            console.log('setVehicleFormFields new value: ' + value);
            raFillingDataForm.setValue('vehicleDetails.acriss', {code: value.acrissCode, description: value.acrissLabel});
            raFillingDataForm.setValue('vehicleDetails.sipp', {code: value.sippCode, description: value.sippLabel, acrissCode: value.acrissCode, acrissLabel: value.acrissLabel});
            raFillingDataForm.setValue('vehicleDetails.plate', {plate: {code: value.plate},  fullDescription: value.fullDescription});
        }


		    raFillingDataForm.setValue('vehicleDetails.vehicleID', !!value?.vin ? value.vin : '');
        raFillingDataForm.setValue('vehicleDetails.kmOnStart', !!value?.kms ? value.kms : '');
		    raFillingDataForm.setValue('vehicleDetails.tankLevelOnStart', !!value?.currentTermicTankFilling ? value.currentTermicTankFilling + '/8': '');
		    raFillingDataForm.setValue('vehicleDetails.batteryLevelOnStart', !!value?.currentElectricTankFilling ? value.currentElectricTankFilling + '%': '');
		    raFillingDataForm.setValue('vehicleDetails.enginePowerGroupCode', !!value?.enginePowerGroupCode ? value.enginePowerGroupCode : '');
		    raFillingDataForm.setValue('vehicleDetails.rdfiCard', !!value?.rfidCardNumber ? value.rfidCardNumber : '');
		    raFillingDataForm.setValue('vehicleDetails.chargingCableDomesticType', !!value?.chargingCableDomesticType ? value.chargingCableDomesticType : '');
		    raFillingDataForm.setValue('vehicleDetails.chargingCableType2', !!value?.chargingCableType2 ? value.chargingCableType2 : '');
		    raFillingDataForm.setValue('vehicleDetails.carClassDescription', !!value?.carClassDescription ? value.carClassDescription : '');
		    raFillingDataForm.setValue('vehicleDetails.carSegmentDescription', !!value?.carSegmentDescription ? value.carSegmentDescription : '');

        
		    //raFillingDataForm.setValue('vehicleDetails.keyless', value?.keyless ? 'true' : 'false');
        //raFillingDataForm.setValue('vehicleDetails.keylessInfo', value?.keylessInfo ? value.keylessInfo : '');

        raFillingDataForm.setValue('vehicleDetails.keyless', raDetail?.generalInfo?.keyless ? 'true' : 'false');
        raFillingDataForm.setValue('vehicleDetails.keylessInfo', raDetail?.generalInfo?.keylessInfo ? raDetail.generalInfo?.keylessInfo : '');


        console.log('setVehicleFormFields vehicleDetails: ' + raFillingDataForm.getValues('vehicleDetails'));
	}




    ////////////////////////////////////////////////////////////////////// UTILITY START


    const viewErrorMessage = (message: string, type = snackbarTypes.error) => {
      setLoading(false);
		dispatchGlobalData({
			type: 'SET_SNACKBAR',
			payload: {
				snackbar: {
					message: t(message),
					type: type,
					show: true,
					autoClose: true,
				}
			}
		});
	}


    const onFormError = (data: any) => {
        console.log('onFormError', data);
    }

    const onSubmit = (data: IRaEditForm) => {
      setLoading(true);
      handleCloseSaveDialog();
      console.log("onSubmit data: " + data);
      console.log("onSubmit raDetail: " + raDetail);

      const rre = data.vehicleDetails.plate;

      if (!rre) {
        console.log(data.vehicleDetails.plate, rre);
        viewErrorMessage("invalid plate");
        return;
      }

      console.log("onSubmit rre: " + rre);

      if (rre.plate !== raDetail.generalInfo.plateNumber) {
        
        console.log("onSubmit updateVehicle with new plate " + rre.plate);

        raEdit({
          keyless: true,
          keylessInfo: data.keylessInfo,
          idRentalAgreement: params.id,
          vehicle: {
            acrissId: rre.acrissCode,
            acrissDescription: rre.acrissLabel,
            sippId: rre.sippCode,
            sippDescription: rre.sippLabel,

            plate: {
              code: rre.plate,
              description: rre.plate,
              label: rre.plate,
            },

            kilometersOnStart: rre.kms,

            carClassDescription: rre.carClassDescription,
            carSegmentDescription: rre.carSegmentDescription,
            brandDescription: rre.brandDescription,
            modelDescription: rre.modelDescription,

            rfidCard: rre.rfidCardNumber,

            currentTermicTankFilling: rre.currentTermicTankFilling,
            currentElectricTankFilling: rre.currentElectricTankFilling,

            termicTankCapacity: rre.termicTankCapacity,
            electricTankCapacity: rre.electricTankCapacity,

            internalNumber: rre.internalNumber,
            vin: rre.vin,
          },
        })
          .then((response:any) => {
            //window.location.reload();
            console.log("onSubmit raEdit response: " + response);
            //checkAndUpdateAncillaries();
            returnToDetail();
          })
          .catch((err: any) => viewErrorMessage(err.toString()));
      }else{
        // try{
        //   console.log("onSubmit No vehicle Update!");
        //   checkAndUpdateAncillaries();
        // }catch(error: any){
        //   viewErrorMessage(error);
        // }

        raEdit({
          keyless: true,
          idRentalAgreement: params.id}).then((response: any) => {
            console.log("createAncillariesFromCountSaleAndUpdate raEdit response: " + response );
            returnToDetail();
          }).catch((error : any) =>{
            console.log("createAncillariesFromCountSaleAndUpdate raEdit error: " + error );
            viewErrorMessage(error);
          });
      }
    };

    const checkAndUpdateAncillaries = () => {
      const ancillariesFormValues = raFillingDataForm.getValues('ancillariesInfo.booked');
      let toUpdate = false;

      console.log('checkAndUpdateAncillaries ancillariesFormValues: ' + JSON.stringify(ancillariesFormValues));

      for(let i = 0; i < ancillariesFormValues.length; i++ ){
        let anc= ancillariesFormValues[i] as unknown as IRADAncillary;
        console.log('checkAndUpdateAncillaries Check anc: ' + anc.editStartValue + ' --- ' + anc.ancillaryCount)
        if(anc.editStartValue !== anc.ancillaryCount){
          toUpdate = true;
         }
      }

      //if(toUpdate){
        createAncillariesFromCountSaleAndUpdate(
          counterSaleManagement.last,
          raFillingDataForm
        );
        createPayloadForAncillaryUpdate();
      // }else{
      //   returnToDetail();
      // }

    }


    const returnToDetail=() =>{
      navigate(`/network/ra-detail/${raDetail.idRentalAgreement}`);
    }

    ////////////////////////////////////////////////////////////////////// UTILITY END

    return loading ? (
      <></>
    ) : (
      <>
        <SectionHeader
          title={t("raDetail.header.title")}
          subtitle={
            <Stack direction="row" alignItems="center" columnGap={3}>
              <Stack direction="row" alignItems="end" columnGap={1}>
                <Typography variant="bodyLarge">
                  {t("raDetail.header.subtitle.idRentalAgreement")}
                </Typography>
                <Typography variant="bodyLarge">
                  {raFilling?.idRentalAgreement}
                </Typography>
              </Stack>

              <Stack direction="row" alignItems="end" columnGap={1}>
                <Typography variant="bodyLarge">
                  {t("raDetail.header.subtitle.status")}
                </Typography>
                <Typography variant="bodyLarge">
                  {raFilling?.generalInfo?.raState?.description}
                </Typography>
              </Stack>

              <Stack direction="row" alignItems="end" columnGap={1}>
                <Typography variant="bodyLarge">
                  {t("raDetail.header.subtitle.raOwner")}
                </Typography>
                <Typography variant="bodyLarge">
                  {raFilling?.generalInfo?.raOwnerFirstName}{" "}
                  {raFilling?.generalInfo?.raOwnerLastName}
                </Typography>
              </Stack>

              <Stack direction="row" alignItems="end" columnGap={1}>
                <Typography variant="bodyLarge">
                  {t("raDetail.header.subtitle.totalAmount")}
                </Typography>
                <Typography variant="bodyLarge">
                  { formatCurrency(locale as LOCALES, raFilling?.quotationInfo?.totalAmountTaxIncluded)}
                </Typography>
              </Stack>
            </Stack>
          }
        />

        <br style={{ marginBottom: theme.spacing(1) }} />

        <FormProvider {...raFillingDataForm}>
          <div style={{ padding: theme.spacing(1) }}>
            <Typography variant={"bodyLarge"}>
              {t("raFilling.vehicleDetails.form.title")}
            </Typography>
          </div>

          <Box
            sx={{
              border: "1px solid",
              borderColor: theme.palette.neutral.light,
              borderRadius: 2,
              bgcolor: theme.palette.neutral.main,
              px: theme.spacing(1),
              pb: theme.spacing(1),
              mb: theme.spacing(1),
            }}
          >
            {/* Vehicle Filters*/}
            <Grid container columnSpacing={2}>
              <Grid item xs={12} sm={6} md={3}>
                <FormAutocomplete<IRaEditForm>
                  name="vehicleDetails.acriss"
                  label={t("raFilling.vehicleDetails.form.label.acriss")}
                  fullWidth
                  //@ts-ignore
                  options={selectionCarOptionList.acriss}
                  isOptionEqualToValue={(option, value) =>
                    option?.code === value?.code
                  }
                  getOptionLabel={(opt) => opt?.code + " - " + opt?.description}
                  onChange={handleChangeAcriss || []}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <FormAutocomplete<IRaEditForm>
                  name="vehicleDetails.sipp"
                  label={t("raFilling.vehicleDetails.form.label.sipp")}
                  fullWidth
                  // @ts-ignore
                  options={selectionCarOptionList.sipp}
                  isOptionEqualToValue={(option, value) =>
                    option?.code === value?.code
                  }
                  getOptionLabel={(opt) =>
                    !!opt?.description
                      ? opt?.code + " - " + opt?.description
                      : "Sipp Less"
                  }
                  onChange={handleChangeSipp || []}
                />
              </Grid>

              <Grid
                item
                xs={12}
                md={6}
                sx={{
                  px: theme.spacing(0),
                  display: "flex",
                  alignItems: "flex-end",
                }}
              >
                <FormAutocomplete<IRaEditForm>
                  name="vehicleDetails.plate"
                  label={t("raFilling.vehicleDetails.form.label.plateNumber")}
                  fullWidth
                  // @ts-ignore
                  options={selectionCarOptionList.plate}
                  isOptionEqualToValue={(option, value) =>
                    option?.plate === value?.plate
                  }
                  getOptionLabel={(opt) => opt?.fullDescription}
                  onChange={handleChangePlate || []}
                />

                <Button
                  color={"accent"}
                  onClick={handleReset}
                  sx={{ mx: theme.spacing(1), mb: theme.spacing(0.5) }}
                >
                  {t("raFilling.vehicleDetails.button.reset")}
                </Button>
              </Grid>
            </Grid>
          </Box>

          <div style={{ padding: theme.spacing(1) }}>
            <Grid container columnSpacing={2}>
              <Grid
                container
                item
                xs={12}
                md={6}
                columnSpacing={2}
                sx={{ mb: "auto", display: "flex", alignItems: "flex-start" }}
              >
                <Grid item xs={12} sm={6}>
                  <FormTextField<IRaEditForm>
                    name="vehicleDetails.vehicleID"
                    label={t("raFilling.vehicleDetails.form.label.vehicleID")}
                    control={raFillingDataForm.control}
                    fullWidth
                    disabled
                  />
                </Grid>
                <Grid item xs={0} sm={6} />

                <Grid item xs={12} sm={6}>
                  <FormTextField<IRaEditForm>
                    name="vehicleDetails.kmOnStart"
                    label={t("raFilling.vehicleDetails.form.label.kmOnStart")}
                    control={raFillingDataForm.control}
                    fullWidth
                    disabled
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <FormTextField<IRaEditForm>
                    name="vehicleDetails.tankLevelOnStart"
                    label={t(
                      "raFilling.vehicleDetails.form.label.tankLevelOnStart"
                    )}
                    control={raFillingDataForm.control}
                    fullWidth
                    disabled
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <FormTextField<IRaEditForm>
                    name="vehicleDetails.batteryLevelOnStart"
                    label={t(
                      "raFilling.vehicleDetails.form.label.batteryOnStart"
                    )}
                    control={raFillingDataForm.control}
                    fullWidth
                    disabled
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <FormTextField<IRaEditForm>
                    name="vehicleDetails.rdfiCard"
                    label={t("raFilling.vehicleDetails.form.label.rdfiCard")}
                    control={raFillingDataForm.control}
                    fullWidth
                    disabled
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <FormRadioGroup<IRaEditForm>
                    name="vehicleDetails.chargingCableType2"
                    label={t(
                      "raFilling.vehicleDetails.form.label.chargingCableType2"
                    )}
                  >
                    <FormControlLabel
                      value="NO"
                      label={t("common.button.no")}
                      disabled
                      control={<Radio />}
                    />
                    <FormControlLabel
                      value="YES"
                      label={t("common.button.yes")}
                      disabled
                      control={<Radio />}
                    />
                  </FormRadioGroup>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <FormRadioGroup<IRaEditForm>
                    name="vehicleDetails.chargingCableDomesticType"
                    label={t(
                      "raFilling.vehicleDetails.form.label.chargingCableDomesticType"
                    )}
                  >
                    <FormControlLabel
                      value="NO"
                      label={t("common.button.no")}
                      disabled
                      control={<Radio />}
                    />
                    <FormControlLabel
                      value="YES"
                      label={t("common.button.yes")}
                      disabled
                      control={<Radio />}
                    />
                  </FormRadioGroup>
                </Grid>

                <Grid item xs={6}>
                  <FormRadioGroup<IRaEditForm>
                    name="vehicleDetails.specialConditions"
                    label={t(
                      "raFilling.vehicleDetails.form.label.specialConditions"
                    )}
                    readOnly
                  >
                    <FormControlLabel
                      value="false"
                      label={t("common.button.no")}
                      disabled
                      control={<Radio />}
                    />
                    <FormControlLabel
                      value="true"
                      label={t("common.button.yes")}
                      disabled
                      control={<Radio />}
                    />
                  </FormRadioGroup>
                </Grid>

                <Grid item xs={6}>
                  <FormRadioGroup<IRaEditForm>
                    name="vehicleDetails.keyless"
                    label={t("raFilling.vehicleDetails.form.label.keyLess")}
                    control={raFillingDataForm.control}
                    readOnly
                  >
                    <FormControlLabel
                      value="false"
                      label={t("common.button.no")}
                      disabled
                      control={<Radio />}
                    />
                    <FormControlLabel
                      value="true"
                      label={t("common.button.yes")}
                      disabled
                      control={<Radio />}
                    />
                  </FormRadioGroup>
                </Grid>
                <Grid item xs={6}>
                  <FormTextField
                    name="keylessInfo"
                    label={t("raFilling.generalInfo.form.label.keyLessInfo")}
                    disabled
                  />
                </Grid>
              </Grid>

              <Grid container item xs={12} md={6} columnSpacing={2}>
                <Grid item xs={12}>
                  <img
                    src={"/images/network/Panda.png"}
                    className="img-width-100"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography variant={"body"}>{brandModelDescr}</Typography>
                </Grid>
              </Grid>
            </Grid>
          </div>

          {/* <Box sx={{
                    border: '1px solid',
                    borderColor: theme.palette.neutral.light,
                    borderRadius: 2,
                    bgcolor: theme.palette.neutral.main,
                    px: theme.spacing(1),
                    pb: theme.spacing(1),
                    mb: theme.spacing(1),
                }}>
                    <Grid item xs={6}>
                        <FormTextField
                            name="keylessInfo"
                            label={t("raFilling.generalInfo.form.label.keyLessInfo")}
                        />
                    </Grid>
                </Box> */}

          {
            <AncillariesInfoTest/>
          }

<Grid item xs={12} sx={{ marginTop: theme.spacing(2) }}>
  <Stack
    direction="row"
    spacing={2}
    justifyContent="space-between" // Distribuisce i pulsanti ai margini opposti
    alignItems="center"
  >
    <Button variant="contained" onClick={returnToDetail}>
      {t("dmsDetail.keyless.infoTab.button.cancel")}
    </Button>

    <Button variant="contained" onClick={handleOpenSaveDialog}>
      {t("dmsDetail.keyless.infoTab.button.edit")}
    </Button>
  </Stack>
</Grid>


          {/* <br style={{ paddingTop: "2rem" }} />
                <input type="checkbox" onChange={(e) => setShowDebugInfo(e.target.checked)} /><span>Debug Info</span>
                {showDebugInfo && <pre>{ JSON.stringify(raFilling, null, 2) }</pre>} */}
        </FormProvider>

        <Dialog
          open={isSaveDialogOpen}
          onClose={handleCloseSaveDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {t("dmsDetail.keyless.infoTab.dialog.title")}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {t("dmsDetail.keyless.infoTab.dialog.content")}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleCloseSaveDialog}
              variant={"outlined"}
              color={"accent"}
            >
              {t("dmsDetail.keyless.infoTab.dialog.action.cancel")}
            </Button>
            <Button
              onClick={raFillingDataForm.handleSubmit(onSubmit, onFormError)}
              autoFocus
            >
              {t("dmsDetail.keyless.infoTab.dialog.action.confirm")}
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
}

export default EditRa;
